import { createContext } from 'react'

const keepaliveContext = createContext({})

export default keepaliveContext